import { useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "../lib/api";

export default function ReceiptLink({ r }) {
  const [busy, setBusy] = useState(false);
  const open = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(`/receipts/${r.id}/file`, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      window.open(url, "_blank", "noopener");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) { toast.error(errMsg(e, "Não foi possível abrir o comprovativo")); } finally { setBusy(false); }
  };
  const tone = { submitted: "text-amber-700", accepted: "text-bo-green", rejected: "text-red-600" }[r.status];
  const label = { submitted: "Em validação", accepted: "Aceite", rejected: "Rejeitado" }[r.status];
  return (
    <button onClick={open} type="button" className="flex w-full items-center gap-3 rounded-xl border border-gray-100 p-3 text-left text-sm hover:border-bo-green" data-testid={`receipt-${r.id}`}>
      {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <FileText className="h-5 w-5 text-bo-green" />}
      <span className="min-w-0 flex-1"><span className="block truncate font-medium">{r.original_filename}</span>
        <span className="text-xs text-gray-500">{fmtDate(r.created_at)} · {Math.max(1, Math.ceil(r.size / 1024))} KB</span></span>
      <span className={`text-xs font-semibold ${tone}`}>{label}</span>
      {r.review_note && <span className="text-xs text-red-600">{r.review_note}</span>}
    </button>
  );
}
